import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/ru';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'timeAgo',
  pure: false, // Re-run when locale changes so notifications (e.g. "mins ago") use current language
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private _translateService: TranslocoService) {}

  transform(
    dateObj: any,
    inputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
    timeZone = moment.tz.guess(),
  ): string {
    // Prefer active UI language so notification bar always uses current lang (fixes "mins ago" in Arabic when UI is Russian/English)
    const lang = this._translateService.getActiveLang() || localStorage.getItem('lang') || 'en';
    const momentLocale = lang === 'ar' ? 'ar' : lang === 'ru' ? 'ru' : 'en';
    const momentObj = moment.utc(dateObj, inputFormat).tz(timeZone);

    // Use moment's locale so fromNow() returns the full string in the correct language
    return momentObj.locale(momentLocale).fromNow();
  }
}
